"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var modal_1 = require("../modules/modal");
var STYLES = {
    CONTENT: ['size-fit'],
    IMAGE: ['size-full', 'max-h-[80vh]', 'max-w-[80vw]'],
};
var CLOSE_BUTTON_CLASS = 'modal-close-btn';
var strategy = {
    createContents: function (button) {
        var originalImg = button.querySelector('img');
        var imgSrc = originalImg === null || originalImg === void 0 ? void 0 : originalImg.getAttribute('src');
        var imgAlt = originalImg === null || originalImg === void 0 ? void 0 : originalImg.getAttribute('alt');
        var contentsTemplate = "\n      <div class=\"".concat(STYLES.CONTENT.join(' '), " relative\">\n        <div class=\"bg-white relative p-4 flex flex-col\">\n          <div class=\"flex justify-end\">\n            <button type=\"button\" class=\"").concat(CLOSE_BUTTON_CLASS, " text-2xl text-light_black font-bold z-10\">&times;</button>\n          </div>\n          <img class=\"").concat(STYLES.IMAGE.join(' '), " mt-2\" src=\"").concat(imgSrc, "\" alt=\"").concat(imgAlt, "\" />\n        </div>\n      </div>\n    ");
        return contentsTemplate;
    },
};
var modal = new modal_1.Modal(strategy);
// モーダルのcloseボタンで閉じる処理
document.addEventListener('click', function (e) {
    var target = e.target;
    if (target.classList.contains(CLOSE_BUTTON_CLASS)) {
        if (modal && typeof modal['close'] === 'function') {
            modal['close']();
        }
    }
});
